import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { Md5 } from 'ts-md5';
import { environment } from 'src/environments/environment';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { User } from 'src/app/interfaces/user.interface';

@Injectable({
    providedIn: 'root',
})
export class AccountService {
    private isAuthenticated = false;
    private token: string = '';
    private tokenTimer: any;
    private userId: string = '';
    private authStatusListener = new Subject<boolean>();
    public err = new BehaviorSubject<any>(null);
    dialogRef: MatDialogRef<DialogComponent> | undefined;

    constructor(private http: HttpClient, private router: Router,private dialog: MatDialog,private translate: TranslateService) {}

    getToken() {
        return this.token;
    }

    getIsAuth() {
        if (!this.isAuthenticated) {
            this.validateAuthWithLocalStorage();
        }
        return this.isAuthenticated;
    }
    getUserData() {
        let userInfo:any = JSON.parse(localStorage.getItem('userInfo')||'null');
        if (window.navigator.onLine) {
            return new Promise<boolean>((resolve, reject) => {
                if (userInfo) {
                    this.http.post(environment.backEndUrl + '/httpAuthGetUserById',{ uid: userInfo.uid })
                    .subscribe((res)=>{

                        userInfo = res;
                        localStorage.setItem('userInfo', JSON.stringify(userInfo));
                        this.saveUserInfoInDB(res)
                    }, (err) => {
                    },
                    ()=>{
                        if(!this.checkUserExpires(userInfo )){
                            this.signOut();
                            this.router.navigate(['/']);
                        }
                        resolve(true)
                        }
                    )


                }else {
                    return resolve(true)
                }
            })

        } else {

            return new Promise<boolean>((resolve, reject) => {
            if (userInfo) {

                if(!this.checkUserExpires(JSON.parse(userInfo) )){
                    this.signOut();
                    this.router.navigate(['/']);
                }
                resolve(true)
            }else {
                return resolve(true)
            }
        })
        }

    }
    validateAuthWithLocalStorage() {
        // const token = localStorage.getItem('token');
        // const time = localStorage.getItem('expiration') || '';

        // if (
        //     token &&
        //     Date.parse(time.toString()) > Date.parse(new Date().toString())
        // )
        const userId = localStorage.getItem('userId');
        const userInfo = localStorage.getItem('userInfo');
        if (userId && userInfo) this.isAuthenticated = true;



    }

    getUserId() {
        return this.userId;
    }
    getAuthStatusListener() {
        return this.authStatusListener.asObservable();
    }

    signIn(email: string, password: string) {
        const authData = { email: email, password: password };
        return new Promise<object>((resolve, reject) => {
            this.http
                .post<UserData>(
                    environment.backEndUrl + '/httpAuthLogin',
                    authData
                )
                .subscribe(
                    (response) => {
                        if (
                            response &&
                            response.stsTokenManager &&
                            response.stsTokenManager.accessToken
                        ) {
                            const token = response.stsTokenManager.accessToken;
                            this.token = token;
                            if (token) {
                                const expirationTime: number =
                                    response.stsTokenManager.expirationTime;
                                const userInfo = response.userInfo || {};
                                this.isAuthenticated = true;
                                this.userId = userInfo.uid;
                                this.authStatusListener.next(true);
                                // const expirationDate = new Date(expirationTime);
                                this.setAuthData(
                                    token,
                                    this.userId,
                                    password,
                                    userInfo
                                );
                                resolve({ status: true ,user:userInfo});
                            }
                        } else {
                            resolve({ status: false });
                        }
                    },
                    (err: any) => {
                        this.err.next(err);
                        resolve({ status: false });
                    }
                );
        });
    }

    checkUserExpires(user:any) {
        let errorMsg = '';
        if (user&&user.endDate && user.startDate) {
            let endDate = moment(user.endDate, "DD/MM/YYYY");
            let startDate = moment(user.startDate, "DD/MM/YYYY");
            let today =  moment();
            if ((moment(startDate).isSameOrBefore(today, 'day')) && moment(today).isSameOrBefore(endDate, 'day') ) {
                return true;
            }else
            if (moment(today).isBefore(startDate, 'day')) {
                errorMsg = this.translate.instant('GENERAL.IT_WILL_BE_ACTIVE_ON')+user.startDate

            }else
            if (moment(endDate).isBefore(today, 'day')) {
                errorMsg = this.translate.instant('GENERAL.THE_END_OF_THE_SUBSCRIPTION_WAS')+user.endDate
            }
        }

        this.dialogRef = this.dialog.open(DialogComponent);
        this.dialogRef.componentInstance.heading = 'Information';
        this.dialogRef.componentInstance.messages = [
            'GENERAL.SUBSCRIPTION_EXPIRED',errorMsg
        ];
        return false;
    }

    resetPassword(email?: string) {
        let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        if (userInfo.email || email) {
            return new Promise<object>((resolve, reject) => {
                this.http
                    .post<UserData>(
                        environment.backEndUrl + '/httpAuthResetPassword',
                        { email: email ? email : userInfo.email }
                    )
                    .subscribe(
                        (response) => {
                            this.err.next(null);
                            resolve({ loader: false, status: true });
                        },
                        (err: any) => {
                            this.err.next(err);
                            resolve({ loader: false, status: false });
                        }
                    );
            });
        } else {
            return new Promise<object>((resolve, reject) =>
                resolve({ loader: false, status: false })
            );
        }
    }

    authenticateUserInOfflineMode(email: string, password: string) {
        let usersDB = JSON.parse(localStorage.getItem('usersDB') || '[]');
        const ind = usersDB.findIndex((data: any) => data.email === email);
        if (ind === -1) {
            return { status: false, message: 'AUTH.NO_OFFLINE_USER' };
        } else if (usersDB[ind].password === Md5.hashStr(password)) {
            this.isAuthenticated = true;
            localStorage.setItem(
                'userInfo',
                JSON.stringify(usersDB[ind].userInfo)
            );
            localStorage.setItem('userId', usersDB[ind].userId);
            if(this.checkUserExpires(usersDB[ind].userInfo)){
                this.router.navigate(['/home']);
            }else{
                this.signOut();
                this.router.navigate(['/']);
            }
            return { status: true, message: 'AUTH.LOGIN_SUCCESS' };
        } else {
            return { status: false, message: 'AUTH.INVALID_CREDENTIALS' };
        }
    }

    signUp(userData: User) {
        return new Promise<object>((resolve, reject) => {
            this.http
                .post<{
                    message: string;
                    stsTokenManager: any;
                    providerData: any;
                    uid: string;
                    apiKey: string;
                }>(environment.backEndUrl + '/authClientUserCreate', userData)
                .subscribe(
                    (response) => {
                        this.err.next(null);
                        resolve({ status: false });
                        if (response.stsTokenManager) {
                            const token = response.stsTokenManager.accessToken;
                            this.token = token;
                            if (token) {
                                const expirationTime: number =
                                    response.stsTokenManager.expirationTime;
                                // this.setAuthTimer(expirationTime);
                                this.isAuthenticated = true;
                                this.userId = response.uid;
                                this.authStatusListener.next(true);
                                const expirationDate = new Date(expirationTime);
                                this.setAuthData(
                                    token,
                                    this.userId,
                                    userData.password,
                                    userData,
                                );
                                this.router.navigate(['/home']);
                                resolve({ status: true });
                            }
                        }
                    },
                    (err: any) => {
                        this.err.next(err);
                        resolve({ status: false });
                    }
                );
        });
    }

    signOut() {
        this.token = '';
        this.isAuthenticated = false;
        this.authStatusListener.next(false);
        clearTimeout(this.tokenTimer);
        this.clearAuthData();
        this.router.navigate(['/']);
    }

    private setAuthTimer(duration: number) {
        this.tokenTimer = setTimeout(() => {
            this.signOut();
        }, duration * 1000);
    }
    private setAuthData(
        token: string,
        userId: string,
        password: string,
        userInfo: any = {}
    ) {
        localStorage.setItem('userId', userId);
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.saveUserDataInDB(userId, password, userInfo);
    }
    saveUserDataInDB(userId: string, password: string, userInfo: any = {}) {
        let usersDB = JSON.parse(localStorage.getItem('usersDB') || '[]');
        const ind = usersDB.findIndex((data: any) => data.userId === userId);
        if (ind == -1) {
            usersDB.push({
                userId,
                password: Md5.hashStr(password),
                email: userInfo.email,
                userInfo,
            });
        } else {
            usersDB[ind] = {
                userId,
                password: Md5.hashStr(password),
                email: userInfo.email,
                userInfo,
            };
        }

        localStorage.setItem('usersDB', JSON.stringify(usersDB));
    }

    saveUserInfoInDB( userInfo: any = {}) {
        let usersDB = JSON.parse(localStorage.getItem('usersDB') || '[]');
        const ind = usersDB.findIndex((data: any) => data.userId === userInfo.uid);
        if (!(ind == -1)) {
            usersDB[ind] = {
                userId:userInfo.uid,
                password: usersDB[ind].password,
                email: usersDB[ind].email,
                userInfo,
            };
        }

        localStorage.setItem('usersDB', JSON.stringify(usersDB));
    }
    private clearAuthData() {
        localStorage.removeItem('userId');
        localStorage.removeItem('userInfo');
        // localStorage.removeItem('last-notification');
        this.isAuthenticated = false;
    }
}
interface UserData {
    userInfo: any;
    stsTokenManager: any;
}
interface UserDB {
    userID: string;
    password: string;
    token: string;
}
